/* ═══════════════════════════════════════════════════
   NEWJAISA — HEALTHCARE INDUSTRY PAGE
   File: assets/component-healthcare.js
   Namespace: HcPage · No globals · No jQuery
═══════════════════════════════════════════════════ */

'use strict';

var HcPage = (function () {

  function $(id)   { return document.getElementById(id); }
  function $$(sel) { return Array.from(document.querySelectorAll(sel)); }

  /* ── DEPARTMENT DATA ────────────────────── */
  var DEPT_DATA = {
    admin:      { device: 'Dell OptiPlex 5060 SFF',      spec: 'i5 · 8GB · 256GB SSD',       price: 22000, newPrice: 52000, note: 'Compact, reliable, silent fan' },
    nursing:    { device: 'HP ProOne 400 G5 AiO',        spec: 'i5 · 8GB · 21.5" integrated', price: 26000, newPrice: 62000, note: 'Space-saving all-in-one' },
    pharmacy:   { device: 'Dell OptiPlex 3050 Micro',    spec: 'i3 · 4GB · 128GB SSD',        price: 14999, newPrice: 36000, note: 'Ultra-compact, counter-friendly' },
    radiology:  { device: 'Lenovo ThinkCentre M720q',    spec: 'i7 · 16GB · 512GB SSD',       price: 34000, newPrice: 82000, note: 'High-memory for imaging software' },
    lab:        { device: 'Dell OptiPlex 7060 SFF',      spec: 'i7 · 16GB · 256GB SSD',       price: 32000, newPrice: 78000, note: 'High-performance for lab software' },
    pharmafield:{ device: 'Dell Latitude 5490',          spec: 'i5 · 8GB · 256GB SSD · 14"',  price: 24000, newPrice: 58000, note: 'Lightweight, long battery' }
  };

  var activeDept = 'admin';

  /* ── FORMAT INR ─────────────────────────── */
  function fmtINR(n) {
    if (n >= 100000) return '₹' + (n / 100000).toFixed(1) + ' L';
    return '₹' + n.toLocaleString('en-IN');
  }

  /* ── RENDER RECOMMENDATION ──────────────── */
  function renderRec() {
    var d = DEPT_DATA[activeDept];
    if (!d) return;

    var saving = Math.round(((d.newPrice - d.price) / d.newPrice) * 100);

    var devEl   = $('hc-dr-device');
    var specEl  = $('hc-dr-spec');
    var priceEl = $('hc-dr-price');
    var saveEl  = $('hc-dr-save');
    var noteEl  = $('hc-dr-note');

    if (devEl)   devEl.textContent   = d.device;
    if (specEl)  specEl.textContent  = d.spec;
    if (priceEl) priceEl.textContent = fmtINR(d.price);
    if (saveEl)  saveEl.textContent  = saving + '% cheaper than new';
    if (noteEl)  noteEl.textContent  = d.note;
  }

  /* ── DEPARTMENT TILES ───────────────────── */
  function initDeptTiles() {
    $$('.hc-dept-tile').forEach(function (tile) {
      tile.addEventListener('click', function () {
        $$('.hc-dept-tile').forEach(function (t) { t.classList.remove('hc-on'); });
        tile.classList.add('hc-on');
        activeDept = tile.getAttribute('data-dept') || 'admin';
        renderRec();
      });
    });
  }

  /* ── FAQ ACCORDION ──────────────────────── */
  function initFAQ() {
    $$('.hc-faq-q').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item   = btn.closest('.hc-faq-item');
        if (!item) return;
        var isOpen = item.classList.contains('open');

        $$('.hc-faq-item.open').forEach(function (i) {
          i.classList.remove('open');
          var q = i.querySelector('.hc-faq-q');
          if (q) q.setAttribute('aria-expanded', 'false');
        });

        if (!isOpen) {
          item.classList.add('open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  /* ── SCROLL REVEAL ──────────────────────── */
  function initReveal() {
    if (!('IntersectionObserver' in window)) {
      $$('.hc-reveal').forEach(function (el) { el.classList.add('hc-vis'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var parent   = entry.target.parentElement;
        var siblings = parent
          ? Array.from(parent.children).filter(function (el) {
              return el.classList.contains('hc-reveal') && !el.classList.contains('hc-vis');
            })
          : [];
        var idx = siblings.indexOf(entry.target);
        setTimeout(function () { entry.target.classList.add('hc-vis'); }, Math.max(0, idx * 80));
        io.unobserve(entry.target);
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -30px 0px' });

    $$('.hc-reveal').forEach(function (el) { io.observe(el); });
  }

  /* ── ANCHOR SMOOTH SCROLL ───────────────── */
  function initAnchors() {
    $$('a[href="#hc-cta"]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var el = document.getElementById('hc-cta');
        if (!el) return;
        e.preventDefault();
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  /* ── GUIDE DOWNLOAD PLACEHOLDER ─────────── */
  function initDownloads() {
    var dlBtn = $('hc-dl-guide');
    if (dlBtn) {
      dlBtn.addEventListener('click', function () {
        alert('Downloading: Healthcare IT Procurement Guide\n\nContact business@newjaisa.com to receive the full guide.');
      });
    }
  }

  /* ── INIT ───────────────────────────────── */
  function init() {
    initDeptTiles();
    renderRec();
    initFAQ();
    initReveal();
    initAnchors();
    initDownloads();
  }

  return { init: init };

})();

document.addEventListener('DOMContentLoaded', function () {
  HcPage.init();
});
